import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { useCallItem } from './CallList.hooks'
import { useGroupActions } from 'hooks'

import Avatar from 'components/Avatar'
import Nickname from 'components/Nickname'
import AvatarGroup from 'components/Avatar/AvatarGroup'
import CallListShowMore from './CallListShowMore'

import './style.scss'

const SHOW_MORE_THRESHOLD = 5

const Call = ({ call, attemptJoinGroup }) => {
  const { user, conference_call } = call
  const { t } = useTranslation()

  const { onCallClick } = useCallItem({ call, attemptJoinGroup })

  const totalPeopleInCall =
    conference_call.conference_call_users_count +
    conference_call.anonymous_call_users_count

  const getLabel = (totalPeopleInCall: number, isActive: boolean) => {
    if (totalPeopleInCall >= 18) {
      return t('common.call_full')
    } else {
      if (isActive) {
        return t('common.total_people_in_call', { total: totalPeopleInCall })
      } else {
        return t('common.total_people_was_in_call', {
          total: totalPeopleInCall,
        })
      }
    }
  }

  const isGroupCall = totalPeopleInCall > 1

  return (
    <div className="Call" onClick={onCallClick}>
      <div className="Call__avatar">
        {isGroupCall ? (
          <AvatarGroup users={conference_call?.conference_call_users ?? []} />
        ) : (
          <Avatar user={user} />
        )}
      </div>

      <span
        className={`Call__title Call__title--${
          conference_call?.call_type === 'vdo' ? 'video' : 'call'
        }${conference_call.active ? '-active' : ''}`}
      >
        {isGroupCall ? (
          <span className="Call__title__label">
            {getLabel(totalPeopleInCall, conference_call.active)}
          </span>
        ) : (
          <Nickname user={user} />
        )}
      </span>
    </div>
  )
}

const CallList = ({
  callList,
  showMoreThreshold,
}: {
  callList: Array<any>
  showMoreThreshold?: number
}) => {
  const { attemptJoinGroup, GroupActionConfirmBox } = useGroupActions()

  const _showMoreThreshold = showMoreThreshold || SHOW_MORE_THRESHOLD
  const showMore = callList.length > _showMoreThreshold

  return (
    <Fragment>
      <div className="CallList">
        {callList.slice(0, _showMoreThreshold).map((call: any) => {
          return (
            <Call
              key={call.id}
              call={call}
              attemptJoinGroup={attemptJoinGroup}
            />
          )
        })}

        {showMore && <CallListShowMore />}
      </div>

      <GroupActionConfirmBox />
    </Fragment>
  )
}

export default CallList
